import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { queryClient } from '../../../queryClient';

const key = () => ['instructions_rso'];

const fetchInstructions = async () => {
  const res = await request.get(
    `/Meter/instructions_for_report_rso`,
    null,
    'Не удалось загрузить инструкцию РСО'
  );
  return res;
};

const useInstructionQuery = (options) => {
  const query = useQuery(key(), () => fetchInstructions(), options);

  return {
    data: query.data,
    loading: query.isLoading
  }
}

const handleResetData = () => {
  queryClient.invalidateQueries({ 
    queryKey: key()
  });
  
  queryClient.removeQueries(key());
};

export { useInstructionQuery, handleResetData }